import { useSnapshot } from "valtio"
import { aguserStore, configStore, loginStore } from "../state/CommonState"
import { $c, $cg, $cr, AgAirline, AgInput, Agpassword, AgpasswordSmall, AgPhone, AgPhoneNew, AgSelect } from '../components/AgComponents'
import AguserApi from "../state/AguserApi"
import Api from "../state/Api"
import { useEffect, useRef, useState } from "react"
import { AgDisplay } from "../components/AgComponents"
import MyProfileEntity from "./my-profile-entity"
import EntityApi from "../state/entity-api"
import UsersApis from "../state/users-api"
import { AguserType } from "../state/Types"
import { loader } from "../util/loader"
import { APP_VERSION } from "../util/constants"
import VerifyMobileModal from "../components/VerifyMobileModal"
import PhoneField from "../mui-components/PhoneField"
import ModeEditRoundedIcon from '@mui/icons-material/ModeEditRounded';
import DoneAllRoundedIcon from '@mui/icons-material/DoneAllRounded';

const formatBuildTime = (isoString) => {
    if (!isoString) return '';
    try {
        const d = new Date(isoString);
        if (isNaN(d.getTime())) return isoString;
        return d.toLocaleString('en-IN', {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
        });
    } catch (e) {
        return '';
    }
};

function ChangePassword(props) {
    useSnapshot(loginStore)
    let txtPassword = useRef()
    let txtPassword1 = useRef()
    const aguser = loginStore.userRec.aguserRec

    return (
        <div className="panel" style={{ paddingLeft: '10px', paddingBottom: '3px', border: '1px solid lightgrey' }}>
            <div className="columns">
                <$c n='1'></$c>
                <$c n='3'>
                    <AgpasswordSmall myref={txtPassword} label='New Password'/>
                </$c>
                <$c n='4'>
                    <AgpasswordSmall myref={txtPassword1} label='Re-enter Password' />
                </$c>
                <$c n='2' style={{ paddingBottom: '0px', alignItems: 'flex-end' }}>
                    <button type="button" className="button is-small islink"
                        style={{ marginTop: '0.7rem' }}
                        onClick={(e) => {
                            let p1 = txtPassword.current.value
                            let p2 = txtPassword1.current.value
                            if (p1 !== p2) {
                                configStore.setModalMessage('Passwords do not match')
                                return
                            }
                            Api.post(`${process.env.REACT_APP_API_SERVER}/api/v1/aguser/comparePassword`, {
                                "newPassword": `${p1}`
                            }, (data) => {
                                configStore.setModalMessage('Password Changed! Please login again with new password.')
                                loginStore.reinitialize()
                                localStorage.removeItem('ag_email')
                                localStorage.removeItem('ag_userrec')
                                localStorage.clear()
                                window.location.reload()
                            })
                        }}>
                        Save New Password
                    </button>
                </$c>
                <$c n='1'></$c>
            </div>
        </div>
    )
}
export default function MyProfileNew(props) {
    const [pwdVisible, setPwdVisible] = useState(false)
    const [userProfile , setUserProfile] = useState({})
    const [outlookPassword, setOutlookPassword] = useState("")
    const [outlookVerify, setOutlookVerify] = useState('No')
    const [op, setOp] = useState(false)
    const [verifyFlag, setVerifyFlag] = useState(false)
    const [OTP, setOTP] = useState("")
    const [OTPMsg, setOTPMsg] = useState("")
    const [phoneNumberFlag, setPhoneNumberFlag] = useState(false)
    const [phoneNumber, setPhoneNumber] = useState('')
    const [otpFlag, setOtpFlag] = useState(false)
    const [error, setError] = useState("")
    const [serviceVersions, setServiceVersions] = useState({
        frontend: { version: APP_VERSION, buildTime: null },
        server: { version: '', buildTime: null },
        notification: { version: '', buildTime: null },
        fileserver: { version: '', buildTime: null }
    })
    let title = 'My Profile'
    useSnapshot(loginStore)
    let aguser = loginStore.userRec.aguserRec

    useEffect(() => {
        Api.getServiceVersions().then(res => {
            if (res) setServiceVersions(res);
        });
    }, [])
    useEffect(()=>{
        if(aguser!=undefined && aguser.outlookPassword!=undefined){
            if(aguser.outlookPassword!=outlookPassword && !op){
                setOutlookPassword(aguser.outlookPassword)
                if(aguser.outlookPassword!=undefined){
                    setOutlookVerify(aguser.outlookVerify)
                }
                setOp(true)
            }
        }
    },[JSON.stringify(aguser),op])
    useEffect(()=>{
        if(aguser!=undefined && aguser.outlookPassword!=undefined){
            if(aguser.outlookPassword!=outlookPassword){
                setOutlookVerify('No')
            }else{
                setOutlookVerify('Yes')
            }
        }
    },[outlookPassword])
    const verify = () =>{
        let body = {
            fromemail:aguser.email,
            password:outlookPassword
        }
        const callback = (data) =>{
            loader.hide()
            if(data!=undefined && data.message !=undefined){
                if(data.message=="failed"){
                    configStore.setModalMessage("Your Outlook Passwork Not Verifed Please Check Your Outlook Password.")
                }
                if(data.message=="success"){
                    aguser.outlookPassword = outlookPassword
                    aguser.outlookVerify = 'Yes'
                    setOutlookVerify('Yes')
                    setOp(false)
                    configStore.setModalMessage("Your Outlook Passwork Is Verifed. Please Click To Save Profile Changes.")
                }
            }
        }
        try {
            loader.show()
            AguserApi.outlookVerify(body,callback)
        } catch(error) {
            loader.hide()
        }
        
    }
    useEffect(() => {
        // EntityApi.getList()
        UsersApis.getProfile(aguser.email,setUserProfile)
    }, [])
    console.log('Value of country = ', aguserStore.aguserRec.country)
    if (!aguser || !aguser.phonePrefix || aguser.phonePrefix.length <= 0) aguser.phonePrefix = '+91'
    const containsAtLeastOneNumber = (inputString) => {
        return /\d/.test(inputString);
    }

    const verifyCheck = () => {
        return (
            (
                aguser.phone &&
                phoneNumberFlag &&
                aguser.phonePrefix === '+91' &&
                !aguser.mobileVerified
            ) ||
            (
                aguser.phonePrefix == '+91' &&
                !aguser.mobileVerified
            ) ||
            aguser.phonePrefix !== '+91'
        )
    }

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: '#f0f0f0',
        border: '2px solid grey.500',
        boxShadow: 24,
        borderRadius: '16px',
        pt: 2,
        px: 4,
        pb: 3,
    };
    return (
        <>
            <h1 className="title is-4">{title}</h1>
            <div className="columns">
                <$c n='3'>
                    <AgInput label='First Name' record={aguser} name='firstName' />
                </$c>
                <$c n='3'>
                    <AgInput label='Last Name' record={aguser} name='lastName' />
                </$c>
                <$c n='3'>
                    <AgDisplay label='Email' value={aguser.email} />
                </$c>
                <$c n='3'>

                    <div style={{ display: 'flex', alignItems: 'flex-start' }}>

                        <PhoneField
                            callback={(e) => {
                                aguser.phone = e?.number;
                                aguser.phonePrefix = e?.code;
                                setError(e.error);
                            }}
                            countryCode={aguser.phonePrefix}
                            phone={aguser.phone}
                            disabled={aguser.mobileVerified}
                        />

                        <div
                            style={
                                !aguser.mobileVerified
                                    ? {}
                                    : {
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        width: 'fit-content'
                                    }
                            }
                        >

                            {
                                aguser.mobileVerified &&
                                <label
                                    style={{
                                        fontSize: '10.3px',
                                        color: 'green',
                                        marginLeft: '-26px',
                                        whiteSpace: 'nowrap'
                                    }}
                                >
                                    <DoneAllRoundedIcon sx={{ fontSize: '10.3px', color: 'green' }} />
                                    Verified Number
                                </label>
                            }

                            <button
                                className="button is-small islink"
                                style={
                                    !aguser.mobileVerified
                                        ? {
                                            marginTop: '20px',
                                            marginLeft: '-5px',
                                            borderTopLeftRadius: 0,
                                            borderBottomLeftRadius: 0,
                                            height: '38.56px'
                                        }
                                        : {
                                            marginTop: '4px',
                                            marginLeft: '-5px',
                                            borderTopLeftRadius: 0,
                                            borderBottomLeftRadius: 0,
                                            height: '38.56px'
                                        }
                                }

                                onClick={async () => {

                                    if (!verifyCheck()) {
                                        setPhoneNumber(aguser.phone)
                                    } else {
                                        setOtpFlag(true)
                                    }

                                    if (aguser.phone && aguser.mobileVerified) {

                                        aguser.mobileVerified =
                                            !aguser.mobileVerified

                                        setPhoneNumberFlag(true)

                                    } else {

                                        await AguserApi.GetMobileOTP(
                                            { userRec: aguser },
                                            (result) => {

                                                if (
                                                    result?.data == 'failure' &&
                                                    result.message
                                                ) {
                                                    setOTPMsg(result.message)
                                                }

                                                setVerifyFlag(true)

                                                if (verifyCheck()) {
                                                    setOtpFlag(false)
                                                }
                                            }
                                        )
                                    }
                                }}

                                disabled={
                                    (
                                        aguser.phonePrefix !== '+91' ||

                                        (
                                            aguser.phonePrefix == '+91' &&
                                            aguser.phone.length !== 10
                                        ) ||

                                        (
                                            phoneNumber === aguser.phone &&
                                            verifyCheck()
                                        ) ||

                                        (
                                            verifyCheck() &&
                                            otpFlag
                                        )
                                    )
                                }
                            >
                                {verifyCheck() ? 'Verify' : <ModeEditRoundedIcon />}
                            </button>

                        </div>

                    </div>

                </$c>

            </div>
            <VerifyMobileModal
                verifyFlag={verifyFlag}
                style={style}
                OTP={OTP}
                setOTP={setOTP}
                OTPMsg={OTPMsg}
                setOTPMsg={setOTPMsg}
                containsAtLeastOneNumber={containsAtLeastOneNumber}
                aguserStore={{ aguserRec: aguser }}
                AguserApi={AguserApi}
                setVerifyFlag={setVerifyFlag}
            />
            {
                (!loginStore.isClient()) ? <><div className="columns">
                <$c n='3'>
                <div className="field">

            <label className="label is-small" style={{ marginBottom: '0px' }}>OutLook Password</label>
            <div className="control is-fullwidth">
            <input id="OutLook_Password" className="input is-small" name="OutLook_Password" placeholder="OutLook Password" type="text" value={outlookPassword}
            onChange={(e)=>{
                console.log("++++++++++++++++++++91",e.target.value)
                setOutlookPassword(e.target.value)
            }}/>
            </div></div>
                {/* <AgInput label = 'OutLook Password' record={aguser} name='outlookPassword'/> */}
                </$c>
                {(outlookPassword.length>0 && outlookVerify=='No')?
                <$c n='3'>
                <button className="button islink is-small"
                        style={{ marginTop: '1.2rem', border: '2px solid lightblue', color: 'white' }}
                        onClick={(e) => {
                            verify()
                        }}>
                        Verify
                    </button>
                </$c>:""}
                    <$c n='3'>
                        <div className="field">
                            <label
                                className="label is-small"
                                style={{ marginBottom: '0px' }}
                            >
                                Notifications
                            </label>

                            <label
                                className="checkbox"
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px',
                                    marginTop: '6px'
                                }}
                            >
                                <input
                                    type="checkbox"
                                    checked={aguser.notification.whatsapp || false}
                                    onChange={(e) => {
                                        aguser.notification.whatsapp = e.target.checked
                                    }}
                                />

                                WhatsApp
                            </label>
                        </div>
                    </$c>
            </div>
            </> : <></>
            }
            {(["krishna.m@agraga.com","krishna.m@navexel.com",
                "udayasankari.m@agraga.com","udayasankari.m@navexel.com",
                "udayakumar.k@agraga.com","udayakumar.k@navexel.com",
                "satheesh.c@agraga.com","satheesh.c@navexel.com"
            ].indexOf(loginStore.email)!=-1)?<div className="columns tour4">
                <$c n='12'>
                    <div style={{
                        background: '#F8FAFC',
                        border: '1px solid #E2E8F0',
                        borderRadius: '8px',
                        padding: '12px 16px',
                        marginTop: '10px',
                        marginBottom: '10px'
                    }}>
                        <div style={{ fontWeight: '600', color: '#1E293B', marginBottom: '8px', fontSize: '0.85rem' }}>
                            Application & Services Versions:
                        </div>
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '10px', fontSize: '0.8rem' }}>
                            <div style={{ background: '#FFFFFF', border: '1px solid #E2E8F0', borderRadius: '6px', padding: '8px 12px' }}>
                                <div style={{ color: '#64748B', fontWeight: '600', marginBottom: '2px' }}>Frontend</div>
                                <strong style={{ color: '#2563EB', fontSize: '0.9rem' }}>{serviceVersions.frontend?.version || APP_VERSION}</strong>
                                {serviceVersions.frontend?.buildTime && (
                                    <div style={{ color: '#94A3B8', fontSize: '0.72rem', marginTop: '2px' }}>
                                        {formatBuildTime(serviceVersions.frontend.buildTime)}
                                    </div>
                                )}
                            </div>
                            <div style={{ background: '#FFFFFF', border: '1px solid #E2E8F0', borderRadius: '6px', padding: '8px 12px' }}>
                                <div style={{ color: '#64748B', fontWeight: '600', marginBottom: '2px' }}>Server</div>
                                <strong style={{ color: serviceVersions.server?.version && serviceVersions.server?.version !== 'Offline' ? '#059669' : '#DC2626', fontSize: '0.9rem' }}>
                                    {serviceVersions.server?.version || 'Checking...'}
                                </strong>
                                {serviceVersions.server?.buildTime && (
                                    <div style={{ color: '#94A3B8', fontSize: '0.72rem', marginTop: '2px' }}>
                                        {formatBuildTime(serviceVersions.server.buildTime)}
                                    </div>
                                )}
                            </div>
                            <div style={{ background: '#FFFFFF', border: '1px solid #E2E8F0', borderRadius: '6px', padding: '8px 12px' }}>
                                <div style={{ color: '#64748B', fontWeight: '600', marginBottom: '2px' }}>Notification</div>
                                <strong style={{ color: serviceVersions.notification?.version && serviceVersions.notification?.version !== 'Offline' ? '#059669' : '#DC2626', fontSize: '0.9rem' }}>
                                    {serviceVersions.notification?.version || 'Checking...'}
                                </strong>
                                {serviceVersions.notification?.buildTime && (
                                    <div style={{ color: '#94A3B8', fontSize: '0.72rem', marginTop: '2px' }}>
                                        {formatBuildTime(serviceVersions.notification.buildTime)}
                                    </div>
                                )}
                            </div>
                            <div style={{ background: '#FFFFFF', border: '1px solid #E2E8F0', borderRadius: '6px', padding: '8px 12px' }}>
                                <div style={{ color: '#64748B', fontWeight: '600', marginBottom: '2px' }}>Fileserver</div>
                                <strong style={{ color: serviceVersions.fileserver?.version && serviceVersions.fileserver?.version !== 'Offline' ? '#059669' : '#DC2626', fontSize: '0.9rem' }}>
                                    {serviceVersions.fileserver?.version || 'Checking...'}
                                </strong>
                                {serviceVersions.fileserver?.buildTime && (
                                    <div style={{ color: '#94A3B8', fontSize: '0.72rem', marginTop: '2px' }}>
                                        {formatBuildTime(serviceVersions.fileserver.buildTime)}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </$c></div>:""}
            <div className="columns tour4">
                <$c n='2'>
                    <button style={{ marginTop: '1.0rem', color: 'white' }}
                        className="button islink is-small is-rounded"
                        onClick={() => setPwdVisible(pwdVisible ? false : true)}>
                        Change Password
                    </button>
                </$c>
                <$c n='10'>
                    {
                    (pwdVisible) ? <ChangePassword /> : 
                    <button className="button islink is-small"
                        style={{ marginTop: '1.2rem', border: '2px solid lightblue', color: 'white',float: 'right' }}
                        disabled={(aguser.outlookPassword!=outlookPassword && outlookPassword.length>0)?true:false}
                        onClick={(e) => {
                            if(aguser.outlookPassword!=outlookPassword){
                                aguser.outlookPassword = outlookPassword
                                aguser.outlookVerify = 'No'
                            }
                            console.log('Save clicked')
                            // if (!aguser.phone.match(/^[0-9]{10}$/)) {
                            //     configStore.setModalMessage(`Invalid phone number ${aguser.phone}`)
                            //     return
                            // }
                            if (
                                aguser.phonePrefix === '+91' &&
                                aguser.phone.length > 0 &&
                                aguser.phone === phoneNumber
                            ) {
                                aguser.mobileVerified = !aguser.mobileVerified
                            }
                            aguserStore.aguserRec = new AguserType();   
                            aguserStore.aguserRec.set(aguser)
                            let d = JSON.parse(localStorage.getItem('ag_userrec'))
                            d.aguserRec = JSON.parse(JSON.stringify(aguser))
                            d = JSON.stringify(d)
                            localStorage.setItem('ag_userrec', d)
                            AguserApi.saveProfileUser()
                        }}>
                        Save Profile Changes
                    </button>
                    }
                </$c>
            </div>
            {
                (loginStore.isClient()) ?
                    <div className="columns">
                        <$c n='12'>
                            <MyProfileEntity data={userProfile}/>
                        </$c>
                    </div> : <></>
            }

        </>
    )
}